module.exports = __webpack_public_path__ + "1c401c6e2bad4e79963eee7572771894.svg";